module.exports = __webpack_public_path__ + "static/image4-e7e00ead55e4063eaa3452ed3b31b874.jpg";